module.exports = __webpack_public_path__ + "img/hotel_img_error.76eb77b2.png";